window.slate = window.slate || {};
window.theme = window.theme || {};

// POLYFILL FOR INCLUDES
if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    if (typeof start !== 'number') {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}

/*================ Theme ================*/
/**
 * Theme Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful helpers for theme
 *
 * @namespace helpers
 */

theme.helpers = {
  getLoginUrl: function(config) {
    var requestObj = {
      url: '/apps/openid/api/v1/open_id/authorization',
      type: "GET"
    };

    if (config) {
      requestObj = Object.assign({}, requestObj, config);
    }

    return $.ajax(requestObj);
  },
  handleLogOut: function() {
      var logout_url = 'https://my.fazer.com/identity/connect/endsession?client_id=fazercandystore&ui_locales=en';
    
      $.get('/account/logout').done(function(data) {
        window.location = logout_url
      });
    
  },
  sortObject: function(obj) {
    if (typeof obj != "object" || obj instanceof Array || obj === null)
      return obj;
    var keys = Object.keys(obj);
    keys.sort();
    var newObj = {};
    for (var i = 0; i < keys.length; i++){
      newObj[keys[i]] = this.sortObject(obj[keys[i]])
    }
    return newObj;
  }
};


/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },

  isValidSelector: function(selector) {
    if (typeof(selector) !== 'string') {
        return false;
    }
    try {
        var $element = $(selector);
    } catch(error) {
        return false;
    }
    return true;
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube-nocookie.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '$';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src && src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productUnitPrice: '[data-product-unit-price]',
    productContainsPieces: '[data-product-contains-pieces]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    moveToCustomize: '[data-move-to-customize]',
    title: '.product-title',
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {

    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    this.settings = {};
    this.namespace = '.product';

    var $title = $(selectors.title);
    var title = $title.text().replace(/(\d{1,4})([\s])(g)/, '\$1&nbsp;g');
    $title.html(title);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
    this.settings.imageSize = slate.Image.imageSize($(selectors.productFeaturedImage, this.$container).attr('src'));

    slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

    this.initVariants();
    this.bindCustomProductMoveBtn();

  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Handles change events from the variant inputs
     */
    initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
      this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }

      if (!productJSON.salesUnit) return;

      var unitPrice = variant.price / productJSON.SalesUnit.WeightNet;

      if (variant.sku.indexOf('-pce') !== -1) {
        unitPrice = variant.price / productJSON.Unit.WeightNet;
        $(selectors.productContainsPieces, this.$container).text('');
      } else {
        var text = " \/ {{ pieces }} pcs"
        text = text.replace(/\{\{\s?pieces\s?\}\}/, productJSON.SalesUnit.Pieces);
        text = text.replace(/\s/g, '&nbsp;');
        $(selectors.productContainsPieces, this.$container).html(text);
      }

      $(selectors.productUnitPrice, this.$container)
        .html(slate.Currency.formatMoney(unitPrice, theme.moneyFormat));

    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      $(selectors.productFeaturedImage, this.$container).attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    },

    bindCustomProductMoveBtn: function() {
      $(selectors.moveToCustomize).on('click', function(e) {
        var $target = $(e.target);
        var targetId = $target.attr('href');

        e.preventDefault();
        $('html, body').animate({
          'scrollTop': $(targetId).offset().top
        }, 600);
      });
    }
  });

  return Product;
})();

theme.Header = (function() {
  var selectors = {
    login: '.js-login-link',
    logout: '[data-logout-btn]',
    nav_links: '.site-nav-roomy a, .site-nav a'
  };

  init();

  function init() {
    var loginContainer = $(selectors.login);
    var logout = $(selectors.logout);

    if (loginContainer.length !== 0) {
      loginContainer.each(function() {
        var rootEl = $(this);
        var linkEl = rootEl.find('a');
        var return_url = $(this).data('return_url');
        theme.helpers.getLoginUrl({data: {return_url: return_url}}).done(function(data) {
          var url = data.redirect_url;
          if (rootEl.hasClass('js-create-account')) {
            url = url.concat('&acr_values=UrlParameter:registration');
          }
          linkEl.attr('href', url);
        }).fail(function(data) {
          loginContainer.each(function() {
            var url = !rootEl.hasClass('js-create-account') ? '/account/login' : '/account/register'
            rootEl.find('a').attr('href', url);
          });
        });
      });
    }

    logout.on('click', function() {
      theme.helpers.handleLogOut();
    });

    $(selectors.nav_links).each(function() {
      var href = $(this).prop('href');
      if (href.length === 0) return;
      var url = new URL(href);
      var external_domains = "[\"go.innoflame.fi\"]";

      if (external_domains.indexOf(url.host) !== -1) {
        $(this).addClass('external');
        $(this).on('click', function(e) {
          e.preventDefault();
          var modal = $('#dynamic-content-modal');
          modal.find('.modal-content').html(`<p>${theme.strings.externalDomainNotification}</p><p><a href="${href}" target="_blank">${theme.strings.externalDomainContinue}</a></p>`);
          modal.foundation('open');
        });
      }
    });
  };
})();

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


/*================ Woolman ================*/
// WOOLMAN FUNCTIONS
window.woolman = window.woolman || {};

woolman.cacheSelectors = function() {
  woolman.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#productImage'),
    $thumbImages             : $('#productThumbnails').find('a.thumbnail-link'),
  };
};

woolman.productImageSwitch = function() {
  if (woolman.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    woolman.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      woolman.switchImage(newImage, null, woolman.cache.$productImage);
    });
  }
};

woolman.switchImage = function(src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};

woolman.responsiveVideos = function() {
  var $iframeVideo = $('iframe[src*="youtube-nocookie.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function() {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="responsive-embed widescreen"></div>');
  });

  $iframeReset.each(function() {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

woolman.collectionViews = function() {
  if (woolman.cache.$changeView.length) {
    woolman.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

//-----------------------------------------------------
// AJAX CART FUNCTIONS

// Cart variables and init
var $cartButton, $cartButtonCount, $cart, $cartItemsContainer, $totalPrice, $totalWeight, $emptyCart, $noteField, $gift_field;

woolman.ajaxCartInit = function () {
  $cartButton = $('#miniCartButton'),
    $cartButtonCount = $('#miniCartButton .cart-count'),
    $cart = $('#offCanvasCart'),
    $cartItemsIds = $cart.data('cart-items'),
    $cartItemsKeys = $cart.data('cart-item-keys'),
    $cartItemsContainer = $('#cartItems'),
    $totalPrice = $('#miniCartTotal'),
    $totalWeight = $('#miniCartWeight'),
    $emptyCart = $('#emptyCart'),
    $noteField = $('#minicart-note');
  $gift_field = $('#minicart-is-gift');
  $cartField = $('#CartSpecialInstructions');
  $cartgift_field = $('#cart-is-gift');

  $forms = $('.minicart-form');

  $noteField.on('keyup', function (e) {
    $(e.target).data('is-edited', true);
  });

  $gift_field.on('change', function (e) {
    var _this = $(this);
    Shopify.updateCartAttributes({ "gift_order": _this.is(':checked') }, $.noop);
    if (!$gift_field.checked) {
      $noteField.val('');
      $noteField.trigger('keyup');
    }
  });

  $cartgift_field.on('change', function (e) {
    var _this = $(this);
    Shopify.updateCartAttributes({ "gift_order": _this.is(':checked') }, $.noop);
    if (!$cartgift_field.checked) {
      $cartField.val('');
      $cartField.trigger('keyup');
    }
  });

  $forms.on('submit', function (e) {
    e.preventDefault();
    var _this = $(this);
    var noteval = $noteField.val();

    if ($noteField.data('is-edited') === true) {
      Shopify.updateCartNote(encodeURIComponent(noteval), function () {
        window.location = window.location.origin + _this.attr('action');
      });
    } else {
      window.location = window.location.origin + _this.attr('action');
    }
  });
};

woolman.addToCart = function (form) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: $(form).serialize(),
    dataType: 'json',
    beforeSend: function () {
      $(form).find('input[type=submit]').attr('disabled', 'disabled');
    },
    success: function (lineItem) {
      $(form).find('.alertmsg').remove();
      woolman.renderMiniCart();
      // Use updated quantity delta for datalayer
      const qtyAdded = form.querySelector('input#Quantity')?.value || 1;
      lineItem.quantity = qtyAdded;
      woolman.pushToDataLayer(lineItem, 'product_added_to_cart');
      $('#offCanvasCart').foundation('open', 'addedToCart', form);
    },
    error: function (XMLHttpRequest, textStatus) {
      woolman.onError(XMLHttpRequest, textStatus, form);
    },
    complete: function (jqxhr, text) {
      $(form).find('input[type=submit]').removeAttr('disabled');
    }
  };
  $.ajax(params);
};

woolman.onError = function (XMLHttpRequest, textStatus, sourceForm) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    $(sourceForm).find('.alertmsg').remove();
    $(sourceForm).append('<p class="alertmsg"><i class="fa fa-exclamation-triangle"></i>' + data.description + '</p>');
    //alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

woolman.renderCart = async function () {

  $('#shopify-section-cart a.remove').off('click');
  $('#shopify-section-cart [data-quantity-input]').off('change');
  $('#shopify-section-cart form[action="/cart"]').off('submit');

  const newSectionHtml = await (await fetch(`?section_id=cart`)).text();
  const newSectionParsed = new DOMParser().parseFromString(newSectionHtml, 'text/html');
  const cartEmpty = newSectionParsed.querySelector('.cart-empty');
  const newCartContainer = newSectionParsed.querySelector('.cart-items-container');
  if (cartEmpty) {
    document.querySelector('.cart-items-container').replaceWith(newCartContainer);
    $('.cart-items-footer').hide();
    $('.cart-notes').hide();
    $('.cart-actions').hide();
    $('klarna-placement').hide();
  } else {
    const newCartFormQuantity = newSectionParsed.querySelector('form[action="/cart"] .quantity');
    const newCartFormTotal = newSectionParsed.querySelector('form[action="/cart"] .total-price');
    const newCartItemsWeight = newSectionParsed.querySelector('.totals .weight');
    const newCartItemsTotal = newSectionParsed.querySelector('.totals .price');
    const newCartItemsSavings = newSectionParsed.querySelector('.totals .savings');

    document.getElementById('shopify-section-cart').querySelector('form[action="/cart"] .quantity').replaceWith(newCartFormQuantity);
    document.getElementById('shopify-section-cart').querySelector('form[action="/cart"] .total-price').replaceWith(newCartFormTotal);
    document.getElementById('shopify-section-cart').querySelector('.totals .weight').replaceWith(newCartItemsWeight);
    document.getElementById('shopify-section-cart').querySelector('.totals .price').replaceWith(newCartItemsTotal);
    document.getElementById('shopify-section-cart').querySelector('.totals .savings').replaceWith(newCartItemsSavings);

    const klarnaWidgetEnabled = JSON.parse("true");
    if (klarnaWidgetEnabled) {
      const newKlarnaPrice = newSectionParsed.querySelector('klarna-placement');
      document.getElementById('shopify-section-cart').querySelector('klarna-placement').replaceWith(newKlarnaPrice);
      window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    }

    $('#shopify-section-cart [data-quantity-input]').change(function (e) {
      woolman.changeQuantity(this);
    });

    $('#shopify-section-cart a.remove').click(function (e) {
      const inputField = this.closest('tr').querySelector('input[data-quantity-input]');
      woolman.changeQuantityToZero(inputField);
    });
  }

  $.getJSON('/cart.js', function (cart) {
    if (cart.item_count === 0) {
      $cart.children().not('.no-hide').addClass('hide');
      $emptyCart.removeClass('hide');
      $cartButton.find('.cart-count').remove();
    } else {

      if ($cartButton.find('.cart-count').length === 0) {
        $cartButton.append('<span class="cart-count show-for-large">' + cart.item_count + '</span>');
      } else {
        $cartButtonCount.html(cart.item_count);
      }
    }
  });

};

woolman.renderMiniCart = async function () {

  $('#offCanvasCart [data-quantity="plus"]').off('click');
  $('#offCanvasCart [data-quantity="minus"]').off('click');
  $('#offCanvasCart [data-quantity-input]').off('change');

  const newSectionHtml = await (await fetch(`?section_id=off-canvas-cart`)).text();
  const newSectionParsed = new DOMParser().parseFromString(newSectionHtml, 'text/html');
  const newCartItems = newSectionParsed.querySelector('#cartItems');
  const newCartItemsWeight = newSectionParsed.querySelector('.weight');
  const newCartItemsTotal = newSectionParsed.querySelector('.total');
  document.getElementById('cartItems').replaceWith(newCartItems);
  document.getElementById('offCanvasCart').querySelector('.weight').replaceWith(newCartItemsWeight);
  document.getElementById('offCanvasCart').querySelector('.total').replaceWith(newCartItemsTotal);
  

  const klarnaWidgetEnabled = JSON.parse("true");
  if (klarnaWidgetEnabled) {
    const newKlarnaPrice = newSectionParsed.querySelector('klarna-placement');
    document.getElementById('offCanvasCart').querySelector('klarna-placement')?.replaceWith(newKlarnaPrice);
    window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
    window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
  }


  $('#offCanvasCart [data-quantity="plus"]').click(function (e) {
    e.preventDefault();
    woolman.increaseQuantity(this);
  });

  $('#offCanvasCart [data-quantity="minus"]').click(function (e) {
    e.preventDefault();
    woolman.decreaseQuantity(this);

  });

  $('#offCanvasCart [data-quantity-input]').change(function (e) {
    woolman.changeQuantity(this);
  });

  $.getJSON('/cart.js', function (cart) {
    if (cart.item_count === 0) {
      $cart.children().not('.no-hide').addClass('hide');
      $emptyCart.removeClass('hide');
      $cartButton.find('.cart-count').remove();
    } else {

      if ($cartButton.find('.cart-count').length === 0) {
        $cartButton.append('<span class="cart-count show-for-large">' + cart.item_count + '</span>');
      } else {
        $cartButtonCount.html(cart.item_count);
      }
    }
  });
  if ($emptyCart.is(":visible")) {
    $cart.find('.hide').removeClass('hide');
    $emptyCart.addClass('hide');
  }
};

woolman.UpdateLineItem = function (el) {
  const cartPage = document.getElementById('shopify-section-cart');
  const lineItemContainer = cartPage ? el.closest('[data-cart-item]') : el.closest('.quick-cart-item');
  const qty = $(lineItemContainer).find('[data-quantity-input]').val();
  const lineItemKey = cartPage ? $(lineItemContainer).find('[data-item-key]').val() : $(lineItemContainer).data('item-key');
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    data: {
      quantity: qty,
      id: lineItemKey
    },
    success: function (data) {
      let updatedItem;
      if (data.items_added.length > 0) {
        updatedItem = data.items_added[0];
        eventType = "product_added_to_cart";
      } else if (data.items_removed.length > 0) {
        updatedItem = data.items_removed[0];
        eventType = "product_removed_from_cart";
      }
      lineItem = data.items.find((item) => item.variant_id == updatedItem.variant_id);
      if (!lineItem && updatedItem) {
        // items in items_removed array use a different format for price than cart items...
        updatedItem.price = parseFloat(updatedItem.price) * 100;
        lineItem = updatedItem;
      }
      if (qty == 0) {
        $(lineItemContainer).remove();
      }
      // Use updated quantity delta for datalayer
      lineItem.quantity = updatedItem.quantity;
      woolman.pushToDataLayer(lineItem, eventType)
      if (cartPage) {
        woolman.renderCart();
      } else {
        woolman.renderMiniCart();
      }
    },
    error: function (response) {
      console.error(response.responseJSON.message);
      alert(response.responseJSON.message);
    }
  });
}

woolman.decreaseQuantity = function (el) {
  const inputField = el.closest('.quantity-input-wrapper').querySelector('input[data-quantity-input]');
  let qty = woolman.validateQty(inputField.value);
  qty -= 1;
  if (qty <= 0) {
    qty = 0;
  }
  inputField.value = qty;
  if ($(el).attr('data-container') === 'minicart') {
    woolman.changeQuantity(inputField);
  }
}


woolman.increaseQuantity = function (el) {
  const inputField = el.closest('.quantity-input-wrapper').querySelector('input[data-quantity-input]');
  let qty = woolman.validateQty(inputField.value);
  qty += 1;
  inputField.value = qty;
  if ($(el).attr('data-container') === 'minicart') {
    woolman.changeQuantity(inputField);
  }
}

woolman.changeQuantity = function (inputField) {
  const qty = woolman.validateQty(inputField.value);
  inputField.value = qty;
  woolman.UpdateLineItem(inputField);
}

woolman.changeQuantityToZero = function (inputField) {
  const qty = 0;
  inputField.value = qty;
  woolman.UpdateLineItem(inputField);
}

woolman.validateQty = function (number) {
  if ((parseFloat(number) == parseInt(number)) && !isNaN(number)) {
    // We have a valid number!
  } else {
    // Not a number. Default to 1.
    number = 1;
  }
  return parseInt(number);
}

woolman.pushToDataLayer = function (lineItem, eventType) {
  window.dataLayer = window.dataLayer || [];
  const value = (lineItem.price * lineItem.quantity) / 100;
  const itemPrice = (lineItem.price / 100).toString();
  const productTitle = lineItem.product_title || lineItem.untranslated_product_title;
  const variantTitle = lineItem.variant_title || lineItem.untranslated_variant_title;
  window.dataLayer.push({
    event: eventType,
    ecommerce: {
      currency: Shopify.currency.active,
      value: value.toString(),
      items: [{
        item_id: lineItem.product_id,
        item_name: productTitle,
        item_brand: lineItem.vendor,
        item_category: lineItem.product_type,
        price: itemPrice,
        item_variant: `${lineItem.variant_id} / ${variantTitle}`,
        quantity: lineItem.quantity
      }]
    }
  });
}


woolman.init = function() {
  woolman.cacheSelectors();
  woolman.productImageSwitch();
  woolman.responsiveVideos();
  woolman.ajaxCartInit();
  //woolman.collectionViews();
};


Handlebars.registerHelper('concat', function() {
  var outStr = '';
  for(var arg in arguments){
    if(typeof arguments[arg]!='object'){
      outStr += arguments[arg];
    }
  }
  return outStr;
});

Handlebars.registerHelper('toLowerCase', function(str) {
  return str.toLowerCase();
});//-----------------------------------------------------
// DOCUMENT READY
$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  if (slate.utils.isValidSelector(window.location.hash)) {
    slate.a11y.pageLinkFocus($(window.location.hash));
  }

  $('.in-page-link').on('click', function(evt) {
    if (slate.utils.isValidSelector($(evt.currentTarget.hash))) {
      slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    }
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // Woolman init
  $(woolman.init);

  // ADD TO CART BUTTON
  $('form[action^="/cart/add"]').off('submit').on('submit', function(evt) {
    evt.stopPropagation();
    evt.stopImmediatePropagation();
    evt.preventDefault();
    woolman.addToCart(this);
  });

  // NOSTO ADD TO CART BUTTONS
  $(document).off('submit', '.nosto-block form[action^="/cart/add"]').on('submit', '.nosto-block form[action^="/cart/add"]', function(evt) {
    evt.stopPropagation();
    evt.stopImmediatePropagation();
    evt.preventDefault();
    woolman.addToCart(this);
  });

  // Plus minus buttons
  // This button will increment the value
  $('[data-quantity="plus"]').click(function(e){
    e.preventDefault();
    woolman.increaseQuantity(this);
  });

  // This button will decrement the value till 0
  $('[data-quantity="minus"]').click(function(e) {
    e.preventDefault();
    woolman.decreaseQuantity(this);
  });

  $('[data-quantity-input]').change(function(e){
    woolman.changeQuantity(this);
  });

  $('#shopify-section-cart a.remove').click(function(e){
    const inputField = this.closest('tr').querySelector('input[data-quantity-input]');
    woolman.changeQuantityToZero(inputField);
  });

  // Scroll top
  $('.scroll-top').each(function(){
    $(this).click(function(){
        $('html,body').animate({ scrollTop: 0 }, 'slow');
        return false;
    });
  });

  // Show frontpage slick slider after oninit
  $('.homepage-slider .slider').on('init', function(event, slick){
    $('.homepage-slider').removeClass('hide');
  });

  // Slick slider basic
  $('.slider').slick({
    arrows: false,
    dots: true,
    mobileFirst: true
  });

  // Slick slider with arrows.
  $('.slider_arrows').slick({
    arrows: true,
    dots: true,
    prevArrow: '<button class="slick-prev_arrows"></button>',
    nextArrow: '<button class="slick-next_arrows"></button>',
    mobileFirst: true
  });

  // My Blue Custom - component slider
  $('.slider-blue').slick({
    arrows: true,
    dots: false,
    mobileFirst: true
  });

  // Slick on mobile
  $('.slider-mobile').slick({
    arrows: true,
    dots: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 640,
        settings: "unslick"
      }
    ]
  });

  // Slick slider with thumbnails
  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.slider-nav'
  });
  $('.slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    arrows: false
  });

  // Pause or play slick-slider depending on video state
  var tag = document.createElement('script');

  tag.src = "https://www.youtube-nocookie.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  //Holds a reference to the YouTube player
  var players = [];
  var iframes = $('iframe[src*="youtube-nocookie.com/embed"]');
  iframes.each(function() {
    $(this).addClass("yt-player");
  });

  window.onYouTubeIframeAPIReady = function() {

    var elems1 = document.getElementsByClassName('yt-player');
    for(var i = 0; i < elems1.length; i++) {

      players[i] = new YT.Player(elems1[i], {
        events: {
          'onStateChange': onPlayerStateChange
        }
      });
    }
  };

  function handleVideo(playerStatus) {
    if (playerStatus == -1) {
      // unstarted
      $('.slider').slick('slickPause');
    } else if (playerStatus == 0) {
      // ended
      $('.slider').slick('slickPlay');
    } else if (playerStatus == 1) {
      // playing = green
      $('.slider').slick('slickPause');
    } else if (playerStatus == 2) {
      // paused = red
      $('.slider').slick('slickPlay');
    } else if (playerStatus == 3) {
      // buffering = purple
    } else if (playerStatus == 5) {
      // video cued
    }
  }
  function onPlayerStateChange(event) {
    handleVideo(event.data);
  }

  if (players.length > 0) {
    $('.slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
      //var current = $(slick.$slides[currentSlide]);
      //current.html(current.html());
      $.each( players, function( i, l ){
        if (players[i].getPlayerState() == 1) {
          players[i].pauseVideo();
        }

      });
    });

    $('.slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      //var current = $(slick.$slides[currentSlide]);
      //current.html(current.html());
      $.each( players, function( i, l ){
        if (players[1].getPlayerState() == 1) {
          $('.autoplay').slick({
            autoplay: false,
          });
          $('.slider').slick('slickPause');
        }
        else {
          $('.autoplay').slick({
            autoplay: true,
          });
          $('.slider').slick('slickPlay');
        };
      });
    });
  }

  // Notifications
  $('.callout').each(function() {
    var hasId = $(this).is('[id]');
    var id = $(this).attr('id');
    var storageItem = "callout-dismissed-".concat(id);

    if (hasId && sessionStorage.getItem(storageItem) !== 'true') {
      $(this).removeClass('hide').show();
      if (!$(this).is('[data-dismiss-always]')) {
        $(this).on('close.zf.trigger', function() {
          sessionStorage.setItem(storageItem,'true');
        });
      } else {
        sessionStorage.setItem(storageItem,'true');
      }
    }
  });

  // Collection page
  Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }

  var defaultSort = $('[data-sort-by]').data('sort-by');
  $('[data-sort-by] a')
    .on('click', function() {
      Shopify.queryParams.sort_by = jQuery(this).data('value');
      location.search = jQuery.param(Shopify.queryParams);
    }
  );

  if($('.template-product').length > 0) {
    var nutritionTableTmpl = Handlebars.compile($('#nutrients-table').html());
    var dietsTableTmpl = Handlebars.compile($('#diets-table').html());
    var nutritionsSelector = 'nutritional-info-container';
    var dietsSelector = 'special-diets-container';

    if($('#box-contains').length === 0) {
      var data = productJSON;
      $('#' + nutritionsSelector).replaceWith(nutritionTableTmpl(data));
      $('#' + dietsSelector).replaceWith(dietsTableTmpl(data));
    } else {
      $('.product-info-json').each(function() {
        var prodId = $(this).data('product-id');
        var data = productJSON[prodId];
        $(this).prevAll('.' + dietsSelector).replaceWith(dietsTableTmpl(data));
        $(this).prevAll('.' + nutritionsSelector).replaceWith(nutritionTableTmpl(data));
      });
    }
  }

  if($('.collection-controls').length > 0 ) {
    $('[data-accordion][data-deep-link="true"]').each(function() {
      var id = $(this).find('[data-tab-content]').attr('id');
      var links = $(this).find('[data-tab-content] a');
      links.each(function() {
        var href = $(this).attr('href') ? $(this).attr('href') + '#' + id : '#' + id;
        $(this).attr('href', href);
      });
    });

    var link_tabs = $.map($('[data-accordion][data-deep-link="true"] [data-tab-content]'), (el, i) => {console.log(el, $(this));return el.id});
    var link_tab = window.location.hash.substr(1);
    //console.log('test', link_tabs, link_tab);
    var link_tab_open = link_tabs.includes(link_tab);
    if (link_tab_open) {
      var parent = $('#' + link_tab).parents('[data-accordion]');
      parent.foundation('toggle', $('#' + link_tab));
      parent.get(0).scrollIntoView();
    }
    /*
    var link_tab = window.location.hash.substr(1);
    if(link_tab){
      console.log('toggle', $('#' + link_tab));
      $('#' + link_tab).foundation('toggle', $('.accordion-content').eq(0));
    }
    */
  }

  $('a.dynamic-modal-link').on('click', function(e) {
    var $modal = $('#dynamic-content-modal');
    var $modal_content = $modal.find('.modal-content');
    var href = $(this).attr('href');
    var link_type = $(this).data('link-type');

    $modal_content.html('');

    if (link_type === 'anchor') {
      e.preventDefault();
      var content = $(href).html();
      content = $(content).foundation();
      $modal_content.html(content);
      $modal.foundation('open');
    }

    if (link_type === 'page_link') {
      e.preventDefault();
      $.get(href.concat('.json'), function(data){
        var page_body = '';
        var accordion_splitter = '<!--accordion start-->';
        var accordion_item_splitter = '<!--accordion item-->';
        var original_body = data.page.body_html;

        // if accordion content, build the foundation accordions
        if (original_body.indexOf(accordion_splitter) !== -1 && original_body.indexOf(accordion_item_splitter) !== -1) {
          var original_body_arr = original_body.split(accordion_splitter);
          //handle body
          page_body += original_body_arr.shift();
          var accordion_items = original_body_arr.join('').split(accordion_item_splitter);
          var items_html = '';
          var $accordion = accordion_items.map(function(item) {
            var content = $('<div></div>').append(item);
            var title = content.find('h2:eq(0)').clone();
            var titleClasses = '';
            if (title.attr('class') && title.attr('class').length > 0) {
              titleClasses = ' '.concat(title.attr('class'));
            }
            title = $('<a href="#" class="accordion-title">' + title.html() + '</a>');
            content.find('h2:eq(0)').remove();
            content = $('<div class="accordion-content" data-tab-content></div>').append(content.html());
            var final_content = $('<div class="accordion-item' + titleClasses + '" data-accordion-item></div>').append(content).prepend(title).get(0).outerHTML;
            return final_content;
          });
          $accordion = $('<div class="accordion" data-accordion data-allow-all-closed="true"></div>').append($accordion);
          page_body += $accordion.get(0).outerHTML;
        } else {
          page_body = original_body;
        }
        // build the content
        var content = '<h2>' + data.page.title + '</h2>' + page_body;
        // init foundation for the whole thing
        $($modal_content.html(content)).foundation();
        // open modal
        $modal.foundation('open');
      });
    }
  });

  $('[data-cds-newsletter="true"]').on('submit', function(e) {
    e.preventDefault();
    var $form = $(this);
    var formData = $form.serializeArray().reduce( function(f,c) { f[c.name]=c.value; return f;}, {});
    var formDataStr = JSON.stringify(formData);

    $form.find('[data-form-message]').remove();
    var email_re = /\S+@\S+\.\S+/;

    if (!email_re.test(formData.email)) {
      $form.prepend('<p class="form-message form-message-failure" data-form-message>Email can&#39;t be blank or in wrong format.</p>');
      return;
    }

    $.ajax({
      method: "POST",
      url: "/apps/openid/newsletter/create",
      data: formDataStr,
      contentType: 'application/json',
    }).done(function() {
      $form.prepend('<p class="form-message form-message-success" data-form-message>Thank you for subscribing. Here is your discount code for Fazer Store: FSJEN19G9J2025. The code is valid for one purchase and cannot be combined with other offers, except for discount codes for delivery costs. The code is valid until 31.12.2025.</p>');
    }).fail(function() {
      $form.prepend('<p class="form-message form-message-failure" data-form-message>Newsletter subscription unsuccessful, please try again later.</p>');
    });

  });

  $('.js-gift-accordion').on('click', function() {
    var $field = $(this).find('[type="checkbox"][name="attributes[gift_order]"]');
    $field.prop("checked", !$field.prop("checked")).trigger('change');
  });

  // headerFix
  var headerFixSelectors = {
    header: '[data-section-id="header"]',
    notification: '#site-notification'
  };

  // Calculate header height;
  function setHeaderHeight() {
    var headerHeight = $(headerFixSelectors.header).outerHeight();
    var notificationHeight = $(headerFixSelectors.notification).outerHeight();
    var totalHeight = headerHeight;
    /*
    if (notificationHeight) {
      totalHeight += notificationHeight;
    }
    */
    var root = document.documentElement;
    root.style.setProperty('--header-height', totalHeight + 'px');
  }

  setHeaderHeight();
  $(window).resize(function() {
    setHeaderHeight();
  });

});// Init Foundation
$(document).foundation();
